import type { UserGroupDomain } from './permissions';

type NullableString = string | null | undefined;

export const getObjectDetailHref = ({
  objectId,
  domain,
  canReadObjects,
}: {
  objectId: NullableString;
  domain: UserGroupDomain | null;
  canReadObjects: boolean;
}): string | null => {
  if (!objectId || !domain || !canReadObjects) return null;
  return domain === 'customer'
    ? `/c/objects/${objectId}/details`
    : `/gmn/objects/${objectId}/details`;
};

export const getSystemShipDetailHref = ({
  systemShipId,
  domain,
  canReadObjects,
}: {
  systemShipId: NullableString;
  domain: UserGroupDomain | null;
  canReadObjects: boolean;
}): string | null => {
  if (!systemShipId || !domain || !canReadObjects) return null;
  return domain === 'customer'
    ? `/c/objects/ships/${systemShipId}/details`
    : `/gmn/objects/ships/${systemShipId}/details`;
};

export const getCustomerDetailHref = ({
  customerId,
  customerType,
  domain,
  canReadCustomers,
  effectiveUserCustomerId,
}: {
  customerId: NullableString;
  customerType?: string | null;
  domain: UserGroupDomain | null;
  canReadCustomers: boolean;
  effectiveUserCustomerId?: NullableString;
}): string | null => {
  if (!customerId || !domain || !canReadCustomers) return null;

  if (domain === 'gmn') {
    const customerBasePath =
      customerType === 'heli-provider'
        ? '/gmn/customer-management/helicopter-service-providers'
        : '/gmn/customer-management/customers';
    return `${customerBasePath}/${customerId}/general`;
  }

  if (effectiveUserCustomerId && effectiveUserCustomerId === customerId) {
    return '/c/my-customer/customer/general';
  }

  return null;
};

export const getObjectCategoryDetailHref = ({
  categoryId,
  isGmnAdmin,
}: {
  categoryId: NullableString;
  isGmnAdmin: boolean;
}): string | null => {
  if (!categoryId || !isGmnAdmin) return null;
  return `/gmn/settings/object-categories/${categoryId}`;
};
